class StickerValidator {

  public validate(form, mediaBlob, mediaUrl?): Promise<string[]|null> {
    let errors: string[]|null = [];
    const hasFormat = form.format && form.format.length > 0;
    if (!hasFormat) {
      errors.push('Select sticker format');
    }

    // const hasGreetingText = form.greeting_text && form.greeting_text.length > 0;
    // if (!hasGreetingText) {
    //   errors.push('Add greeting text');
    // }

    const hasTemplate = form.template && form.template != null;
    if (!hasTemplate) {
      errors.push('Select theme template');
    }

    if (mediaBlob == null) {
      errors.push('Media file not selected');
      return new Promise((resolve) => resolve(errors));
    }

    return new Promise((resolve) => {
      errors = (errors as string[]).length > 0 ? errors : null;
      resolve(errors);
    });
  }

  public isMediaExist(blob, url) {
    if (blob == null || url == null || blob === '' || url === '') {
      return new Promise((resolve) => resolve(false));
    }
    return fetch(url)
      .then(() => true)
      .catch(() => false);

  }
}

const stickerValidator = new StickerValidator();
export default stickerValidator;